// extracted by mini-css-extract-plugin
export var date = "HeroPost-module--date--9da8d";
export var featuredImage = "HeroPost-module--featured-image--f2091";
export var heroPost = "HeroPost-module--hero-post--81950";
export var heroPostTitle = "HeroPost-module--hero-post-title--b5c64";
export var transformWithImage = "HeroPost-module--transform-with-image--ecee8";